
export default {
  props: {
    callUsBanner: {
      type: Object,
      default: () => {},
    },
  },
}
